import { render, staticRenderFns } from "./autoNumberSetting.vue?vue&type=template&id=61b6efb0&lang=pug"
import script from "./autoNumberSetting.vue?vue&type=script&lang=js"
export * from "./autoNumberSetting.vue?vue&type=script&lang=js"
import style0 from "./autoNumberSetting.vue?vue&type=style&index=0&id=61b6efb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports